module.exports = __webpack_public_path__ + "img/02.b4d4fee5.png";